import React from 'react';
import classnames from 'classnames';
import styles from './account-menu-item.scss';

import { NotificationDot } from '../notification-dot/NotificationDot';
interface AccountMenuItemProps {
  name: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  showNotification?: boolean;
}

export const AccountMenuItem = ({
  name,
  href,
  className,
  showNotification,
}: AccountMenuItemProps) => {
  const classes = classnames(styles.link);

  const label = showNotification ? `${name}, new notification` : name;

  return (
    <li className={classnames(styles.item, className)}>
      <a className={classes} href={href} aria-label={label}>
        {name}
        {showNotification && <NotificationDot inline />}
      </a>
    </li>
  );
};
